import React from "react";
import {SiteInfo} from "../../api/ApiClient";

export const SiteInfoContext = React.createContext(undefined as undefined | SiteInfo)